import { render } from "./App.vue?vue&type=template&id=6446f218"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=6446f218&lang=css"

import exportComponent from "C:\\Users\\chany\\Desktop\\my\\apache\\project\\youtube\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__